document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.core-mobile-toggle');
  var menu = document.getElementById('core-mobile-menu');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', function () {
    var isOpen = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
});
